const URL = process.env.API_URL || 'https://ffwd.plus:21021';
export default URL;
